import React from 'react'
import { Link } from 'react-router-dom'
// Default images as fallbacks
import DefaultTopImage from '../../images/why.png'
import DefaultMobileImage from '../../images/mob1.svg'
import DefaultMobileImage1 from '../../images/mob33.svg'
import DefaultResImage from '../../images/res.svg'
import { useLanguage } from '../../context/LanguageContext'

const WhyAvopla = () => {
  const { language, translations, loading, getImage } = useLanguage();
  const t = translations[language]?.whyAvopla || {};

  // Get images from API with fallback to local images
  const headerImage = getImage('whyAvopla-header');
  const reachFoodiesImage = getImage('whyAvopla-reachFoodies');
  const customerExpImage = getImage('whyAvopla-customerExperience');
  const controlResImage = getImage('whyAvopla-controlReservations');

  if (loading) {
    return (
      <div className="why-avopla-container">
        <div className="parent-loader">
          <div className="_loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="why-avopla-container">
      <div className="main-header">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-7">
              <div className="content">
                <h2 className="title">
                  {t.hero?.title}
                </h2>
                <div className="flex-30">
                  <Link className="button" to='/registration' style={{ background: '#CA2E54' }}>{t.hero?.registerButton}</Link>
                  <Link className="button" to='/plans' style={{ background: '#3C3C44CC' }}>{t.hero?.exploreButton}</Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5">
              <div className="image-wrapper">
                <img 
                  src={headerImage?.url || DefaultTopImage} 
                  alt={headerImage?.alt || "Restaurant reservations management"} 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 className="main-title text-center mb-40 color-red">
        {t.winWin?.title}
      </h2>
      <h2 className="subtitle text-center mb-70 color-text uppercase">
        {t.winWin?.subtitle}
      </h2>
      <div className="container">
        <div className="avopla-powerful-container mb-80">
          <h3 className="title uppercase">
            {t.powerful?.title}
          </h3>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="item">
                <p className="label">
                  {t.powerful?.reachAudience?.title}
                </p>
                <p className="text">
                  {t.powerful?.reachAudience?.text}
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="item">
                <p className="label">
                  {t.powerful?.takeControl?.title}
                </p>
                <p className="text">
                  {t.powerful?.takeControl?.text}
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="item">
                <p className="label">
                  {t.powerful?.beClose?.title}
                </p>
                <p className="text">
                  {t.powerful?.beClose?.text}
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="item">
                <p className="label">
                  {t.powerful?.limitNoShow?.title}
                </p>
                <p className="text">
                  {t.powerful?.limitNoShow?.text}
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div className="container">
        <div className="image-content-section mb-80">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="image-section left">
                <img 
                  src={reachFoodiesImage?.url || DefaultMobileImage} 
                  alt={reachFoodiesImage?.alt || "Avopla mobile app interface"} 
                />
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="content-section">
                <h2 className="title uppercase">
                  {t.reachFoodies?.title}
                </h2>
                <div className="row">
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.reachFoodies?.largerAudience?.title}
                      </p>
                      <p className="text">
                        {t.reachFoodies?.largerAudience?.text}

                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.reachFoodies?.promotional?.title}
                      </p>
                      <p className="text">
                        {t.reachFoodies?.promotional?.text}


                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.reachFoodies?.whatDiners?.title}
                      </p>
                      <p className="text">
                        {t.reachFoodies?.whatDiners?.text}


                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.reachFoodies?.moreVisible?.title}
                      </p>
                      <p className="text">
                        {t.reachFoodies?.moreVisible?.text}



                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="image-content-section mb-80">
          <div className="row">
             <div className="col-12 col-md-4">
              <div className="image-section left">
                <img 
                  src={customerExpImage?.url || DefaultMobileImage1} 
                  alt={customerExpImage?.alt || "Customer reviews interface"} 
                />
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="content-section">
                <h2 className="title uppercase">
                  {t.customerExp?.title}
                </h2>
                <div className="row">
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.customerExp?.reviewsVisibility?.title}
                      </p>
                      <p className="text">
                        {t.customerExp?.reviewsVisibility?.text}

                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.customerExp?.respondFeedback?.title}
                      </p>
                      <p className="text">
                        {t.customerExp?.respondFeedback?.text}


                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.customerExp?.increaseInfluence?.title}
                      </p>
                      <p className="text">
                        {t.customerExp?.increaseInfluence?.text}


                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.customerExp?.automaticSurvey?.title}
                      </p>
                      <p className="text">
                        {t.customerExp?.automaticSurvey?.text}



                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           

          </div>
        </div>
      </div>
      <div className="container">
        <div className="image-content-section mb-80">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="image-section contain left">
                <img 
                  src={controlResImage?.url || DefaultResImage} 
                  alt={controlResImage?.alt || "Restaurant management dashboard"} 
                />
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="content-section">
                <h2 className="title uppercase">
                  {t.controlReservations?.title}
                </h2>
                <div className="row">
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.controlReservations?.listAll?.title}
                      </p>
                      <p className="text">
                        {t.controlReservations?.listAll?.text}

                      </p>
                    </div>
                  </div>
                 
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.controlReservations?.limitNoShow?.title}
                      </p>
                      <p className="text">
                      {t.controlReservations?.limitNoShow?.text}
 

                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.controlReservations?.manageDining?.title}
                      </p>
                      <p className="text">
                        {t.controlReservations?.manageDining?.text}



                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-4">
                    <div className="item">
                      <p className="label">
                        {t.controlReservations?.takeControlEach?.title}
                      </p>
                      <p className="text">
                        {t.controlReservations?.takeControlEach?.text}


                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
      <div className="footer-top">
        <div className="container">
          <h2 className="title uppercase text-center">
          {t.footerCta?.title}
          </h2>
          <h3 className="subtitle text-center">
          {t.footerCta?.subtitle}
          </h3>
          <div className="d-flex justify-content-center">
            <Link className='button' to='/registration'>{t.footerCta?.button}</Link>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default WhyAvopla